export default {
  LOGIN: '/',
  SIGNUP: '/signup',
  SIGNUPFORM: '/signup/:signupType',
  LOGIN_REDIRECT_PATH: '/dashboard/profile/',
  INFLUENCER_SIGNUP_REDIRECT_PATH: 'https://influencee.it/benvenuto-su-influencee/',
};
